import {toFarsiNumber} from "./toFarsiNumber";

export function toFarsiTime (date) {
    let farsiArray = date.split(':')
    let persianTime=''
    date=''
    farsiArray.map((token,index)=>{
        token  = toFarsiNumber(token)
        if(index ===2)
        {
            persianTime =persianTime + token
        }
        else{
            persianTime =persianTime + token+':'
        }

    })
    return persianTime
}
export function toMinutesTime(date) {
    let farsiArray = date.split(':')
    let persianTime=''
    date=''
    farsiArray.map((token,index)=>{
        if(index ===1)
        {
            persianTime =persianTime + token
        }
        else if(index===2){
            //nothing
        }
        else{
            persianTime =persianTime + token+':'
        }

    })
    return persianTime
}
//برای تبدیل ساعت به ثانیه
export function ConvertOclockToSeconds(time) {
    let times = time.split(':')
    return     Number(times[0])*3600 + Number(times[1])*60

}
